import { SpaceUserTable } from "./SpaceUserTable";
export var SpaceTable;
(function (SpaceTable) {
    let GitRepositoryType;
    (function (GitRepositoryType) {
        GitRepositoryType.map = {};
        GitRepositoryType.Github = 10;
        GitRepositoryType.map[GitRepositoryType.Github] = "Github";
        GitRepositoryType.AzureRepos = 20;
        GitRepositoryType.map[GitRepositoryType.AzureRepos] = "Azure Repos";
        GitRepositoryType.Unknown = 90;
        GitRepositoryType.map[GitRepositoryType.Unknown] = "不明";
    })(GitRepositoryType = SpaceTable.GitRepositoryType || (SpaceTable.GitRepositoryType = {}));
    function hasManage(space) {
        if (space == null) {
            return false;
        }
        const mostStrongAuthorityType = space.most_strong_authority_type;
        return SpaceUserTable.AuthorityType.hasManage(mostStrongAuthorityType);
    }
    SpaceTable.hasManage = hasManage;
})(SpaceTable || (SpaceTable = {}));
